import { NavLink } from "react-router-dom";

function Banner(props) {
  return (
    <div className="container-xxl py-5 bg-dark page-header mb-5">
      <div className="container my-5 pt-5 pb-4">
        <h1 className="display-3 text-white mb-3 animated slideInDown">
          {props.pageName}
        </h1>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb text-uppercase">
            <li className="breadcrumb-item">
              <NavLink to="/">Home</NavLink>
            </li>
            <li
              className="breadcrumb-item text-white active"
              aria-current="page"
            >
              {props.pageName}
            </li>
          </ol>
        </nav>
      </div>
    </div>
  );
}

export default Banner;
